import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SideBarTabs, SidebarTabsType } from "../constants/tabs";

interface PageState {
  active: string;
  progressBarActive: boolean;
  activeTab: SidebarTabsType;
  sidebarActive: boolean;
}

const initialState: PageState = {
  active: "",
  progressBarActive: false,
  activeTab: SideBarTabs.Overview.name,
  sidebarActive: false,
};

export const header = createSlice({
  name: "header",
  initialState,
  reducers: {
    setActivePage: (state, action: PayloadAction<string>) => {
      state.active = action.payload;
    },
    setProgressBarActive: (state, action: PayloadAction<boolean>) => {
      state.progressBarActive = action.payload;
    },
    setActiveTab: (state, action: PayloadAction<SidebarTabsType>) => {
      state.activeTab = action.payload;
    },
    setSidebarActive: (state, action: PayloadAction<boolean>) => {
      state.sidebarActive = action.payload;
    },
  },
});

export const {
  setActivePage,
  setProgressBarActive,
  setActiveTab,
  setSidebarActive,
} = header.actions;

export default header.reducer;
